export enum WebViewDispatcherAction {
  initialised = 'INITIALISED',
  setBadgeCount = 'SET_BADGE_COUNT',
}
